import styled from './ErrorBanner.module.scss'
import ErrorIcon from '../../../../assets/errorIcon.svg'

interface Props {
  errors: string[]
}

const ErrorBanner = ({ errors }: Props) => {
  return (
    <div className={styled.errorsBanner}>
      <div className={styled.title}>
        <img src={ErrorIcon} className={styled.error_icon} />
        <span className={styled.errorsBannerTitle}>
          Algunos datos no se han introducido correctamente
        </span>
      </div>

      {/* <ul className={styled.errors}>
        {errors.map((error) => {
          return (
            <li className={styled.error} key={error}>
              {error}
            </li>
          )
        })}
      </ul> */}
    </div>
  )
}

export default ErrorBanner
